import { render, staticRenderFns } from "./formCount.vue?vue&type=template&id=4c074956&scoped=true"
import script from "./formCount.vue?vue&type=script&lang=js"
export * from "./formCount.vue?vue&type=script&lang=js"
import style0 from "./formCount.vue?vue&type=style&index=0&id=4c074956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c074956",
  null
  
)

export default component.exports